import {Inject, Injectable} from '@angular/core';
import {Meta, MetaDefinition, Title} from '@angular/platform-browser';
import {MetaTag} from '../entities/meta-tags';
import {DOCUMENT} from '@angular/common';
import {ActivatedRoute} from "@angular/router";
import {SeoMetaData} from "../entities/seoMetaData";



@Injectable({
  providedIn: 'root'
})
export class ShareMetaSeoService {
  private typeMeta = 'og:type';
  private urlMeta = 'og:url';
  private titleMeta = 'og:title';
  private descriptionMeta = 'og:description';
  private imageMeta = 'og:image';
  private secureImageMeta = 'og:image:secure_url';

  constructor(
    private title: Title,
    private meta: Meta,
    private route: ActivatedRoute,
    @Inject(DOCUMENT) private doc
  ) {
  }

  updateTitle(title: string): void {
    this.title.setTitle(title);
  }

  updateDescription(desc: string): void {
    this.meta.updateTag({name: 'description', content: desc});
  }

  updateMetaTags(metaTags: MetaDefinition[]): void {
    metaTags.forEach(m => this.meta.updateTag(m));
  }

  updateOpenGraphTags(type: string, title: string, description: string, image: string): void {
    const tags = [
      new MetaTag(this.typeMeta, type),
      new MetaTag(this.urlMeta, this.doc.URL),
      new MetaTag(this.titleMeta, title),
      new MetaTag(this.descriptionMeta, description),
      new MetaTag(this.imageMeta, image),
      new MetaTag(this.secureImageMeta, image)
    ];

    tags.forEach(siteTag => {
      this.meta.updateTag({property: siteTag.name, content: siteTag.value});
    });
  }

  createLinkForCanonicalURL(): void {
    const head = this.doc.getElementsByTagName('head')[0];
    let element: HTMLLinkElement = this.doc.querySelector(`link[rel='canonical']`) || null;
    if (element == null) {
      element = this.doc.createElement('link') as HTMLLinkElement;
      head.appendChild(element);
    }
    element.setAttribute('rel', 'canonical');
    element.setAttribute('href', this.doc.URL);
  }

  updateSeoData(data: SeoMetaData): void {
    if (data?.title) {
      this.updateTitle(data.title)
    }
    if (data?.description) {
      this.updateDescription(data.description)
    }

    if (data?.metaTags) {
      const metaTags = data?.metaTags.reduce((acc: any, tag) => {
        switch (tag.property) {
          case 'og:title':
            acc.title = tag.content;
            break;
          case 'og:description':
            acc.description = tag.content;
            break;
          case 'og:image':
          case 'og:image:secure_url':
            acc.image = tag.content;
            break;
        }
        return acc;
      }, {});

      const description = metaTags.description ? metaTags.description : data.description;
      this.updateOpenGraphTags('website', metaTags.title, description, metaTags.image);
    }
  }
}
